import React from "react";
import {
  Box,
  Heading,
  Text,
} from "@chakra-ui/react";
import MarkdownRenderer from "../../Common/MarkdownRenderer";

const WhatYouWillLearn = ({
  objective,
  outline,
  qualification,
  description: courseDescription,
}) => {
  // Check if content contains markdown syntax or HTML markup
  const hasMarkdownOrHtml = (content) => {
    if (!content) return false;

    const markdownPatterns = [
      /#{1,6}\s+/, // Headers
      /\*{1,2}[^*]+\*{1,2}/, // Bold/Italic
      /`[^`]+`/, // Inline code
      /```[\s\S]*?```/, // Code blocks
      /\[.+\]\(.+\)/, // Links
      /^[-*+]\s+/m, // Unordered lists
      /^\d+\.\s+/m, // Ordered lists
      /^>\s+/m, // Blockquotes
    ];

    const htmlPatterns = [
      /<p[^>]*>/, // Paragraph tags
      /<h[1-6][^>]*>/, // Header tags
      /<strong[^>]*>/, // Strong tags
      /<em[^>]*>/, // Emphasis tags
      /<i[^>]*>/, // Italic tags
      /<b[^>]*>/, // Bold tags
      /<ul[^>]*>/, // Unordered list tags
      /<ol[^>]*>/, // Ordered list tags
      /<li[^>]*>/, // List item tags
      /<br\s*\/?>/, // Line break tags
      /<div[^>]*>/, // Div tags
      /<span[^>]*>/, // Span tags
      /&[a-zA-Z]+;/, // HTML entities like &nbsp;, &amp;, etc.
    ];

    return (
      markdownPatterns.some((pattern) => pattern.test(content)) ||
      htmlPatterns.some((pattern) => pattern.test(content))
    );
  };

  // Render content based on type
  const renderContent = (content) => {
    if (!content) return null;

    // Check if it's simple HTML (like <p>text<br>&nbsp;</p>)
    const isSimpleHTML = /<p[^>]*>.*?<\/p>/i.test(content) && 
                        !content.includes('<ul>') && 
                        !content.includes('<ol>') && 
                        !content.includes('<h1>') && 
                        !content.includes('<h2>');

    if (isSimpleHTML) {
      // For simple HTML paragraphs, render directly with dangerouslySetInnerHTML
      return (
        <Box 
          fontSize="md" 
          color="#555" 
          lineHeight={1.7} 
          mb={4}
          dangerouslySetInnerHTML={{ __html: content }}
          sx={{
            '& p': {
              margin: 0,
              marginBottom: '1rem'
            },
            '& p:last-child': {
              marginBottom: 0
            },
            '& br': {
              lineHeight: 1.7
            }
          }}
        />
      );
    }

    // For complex markdown/HTML, use MarkdownRenderer
    if (hasMarkdownOrHtml(content)) {
      return (
        <Box fontSize="md" color="#555" lineHeight={1.7} mb={4}>
          <MarkdownRenderer content={content} />
        </Box>
      );
    }

    // For plain text
    return (
      <Text fontSize="md" color="#555" lineHeight={1.7} mb={4}>
        {content}
      </Text>
    );
  };

  // const displayDescription = courseDescription || "";

  return (
    <Box mt={8} mb={8} maxW="7xl" mx="auto">
      {/* Course Description */}
      {/* {displayDescription && (
        <Box mb={8}>
          <Heading
            as="h3"
            fontSize={{ base: "lg", md: "xl" }}
            mb={4}
            color="#222"
            fontWeight="600"
          >
            Overview
          </Heading>
          {hasMarkdownOrHtml(displayDescription) ? (
            <MarkdownRenderer content={displayDescription} />
          ) : (
            <Text fontSize="md" color="#555" lineHeight={1.7} mb={4}>
              {displayDescription}
            </Text>
          )}
        </Box>
      )} */}
      {/* Training Objective */}
      {objective && (
        <Box mb={8}>
          <Heading
            as="h3"
            fontSize={{ base: "lg", md: "xl" }}
            mb={4}
            color="#222"
            fontWeight="600"
          >
            Why Join
          </Heading>
          {renderContent(objective)}
        </Box>
      )}
      {/* Course Qualification/Requirements */}
      {qualification && (
        <Box mb={8}>
          <Heading
            as="h3"
            fontSize={{ base: "lg", md: "xl" }}
            mb={4}
            color="#222"
            fontWeight="600"
          >
            This Course is Best Suited For
          </Heading>
          {renderContent(qualification)}
        </Box>
      )}

      {/* What you'll learn / Training Outline */}
      {outline && (
        <Box mb={8}>
          <Heading
            as="h3"
            fontSize={{ base: "lg", md: "xl" }}
            mb={4}
            color="#222"
            fontWeight="600"
          >
            What You'll Learn
          </Heading>
          {renderContent(outline)}
        </Box>
      )}
    </Box>
  );
};

export default WhatYouWillLearn;
